module.exports = __webpack_public_path__ + "img/phone.ff423c4e.svg";